import { toggleClass } from "./_vars";

export const toggleMenu = () => {
    const menu = document.querySelector(".nav");
    const menuToggler = document.querySelector(".burger");
    menuToggler.addEventListener("click", () => {
        toggleClass(menu, "active");
        toggleClass(menu, "show");
        toggleClass(menuToggler, "burger--active");
    });
};

export const setHeightOfHeader = () => {
    if (window.innerHeight >= 991) {
        const head = Math.floor(
            document.querySelector(".header").getBoundingClientRect().height
        );
        document.styleSheets[0].insertRule(`:root{--header-height:${head}px}`);
    }
};

// if (window.innerWidth < 991) {
//     // проверяем ширину экрана
//     let vh = window.innerHeight * 0.01; // получаем 1% высоты экрана
//     document.documentElement.style.setProperty("--vh", `${vh}px`); // устанавливаем значение --vh для использования в CSS
//     window.addEventListener("resize", () => {
//         // отслеживаем изменение размера экрана
//         let vh = window.innerHeight * 0.01;
//         document.documentElement.style.setProperty("--vh", `${vh}px`);
//     });
// }
